import React from 'react';
import { MatchSource } from './types';

interface SourceBadgeProps {
  source: MatchSource;
}

const SourceBadge: React.FC<SourceBadgeProps> = ({ source }) => {
  if (source === 'manual') {
    return <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-purple-100 text-purple-800 dark:bg-purple-900/50 dark:text-purple-300">Manual</span>;
  }
  return <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-indigo-100 text-indigo-800 dark:bg-indigo-900/50 dark:text-indigo-300">Wyscout</span>;
};

export default SourceBadge;
